import { useCallback, useState } from 'react';

export const PATIENT_ACTIONS_MENU_NOTICE_STORAGE_KEY =
  'patient-page-v3.actions-menu-notice-dismissed.v1';

export const usePatientActionsMenuNotice = () => {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(PATIENT_ACTIONS_MENU_NOTICE_STORAGE_KEY) === 'true',
  );

  const dismiss = useCallback(() => {
    localStorage.setItem(PATIENT_ACTIONS_MENU_NOTICE_STORAGE_KEY, 'true');
    setDismissed(true);
  }, []);

  return { dismissed, dismiss };
};
